import { ValueFormatterParams } from 'ag-grid-community'
import moment from 'moment'
import { isNil } from 'lodash-es'
import { AuditDetail } from 'api'
import { getFormattedTime } from 'utils'
import { Locale, Translation } from 'locale'
import { TypedValueGetterParams } from 'view/components/datagrid'
import { CompletedGridColumnId } from './CompletedGridColumnNames'
import { CollectionColumnId } from 'view/routes/ColumnNames'

export function makeNAFormatter(columnId: string) {
  return function NAFormatter(params: ValueFormatterParams) {
    const initiatorColumnIdFilter: string[] = [CompletedGridColumnId.NEGOTIATION_COMPETITION_COUNT]
    const responderColumnIdFilter: string[] = [
      CollectionColumnId.COLLECTION_NAME,
      CompletedGridColumnId.BOOK_NAME,
      CompletedGridColumnId.STRATEGY_NAME,
      CompletedGridColumnId.BUNDLE_NAME
    ]

    if (!params.node || params.node.group) {
      return ''
    }

    if (params.data.ownOrder) {
      return initiatorColumnIdFilter.includes(columnId)
        ? Locale.translate(Translation.UC_NOT_APPLICABLE)
        : isNil(params.value)
        ? ''
        : params.value
    } else {
      return responderColumnIdFilter.includes(columnId)
        ? Locale.translate(Translation.UC_NOT_APPLICABLE)
        : isNil(params.value)
        ? ''
        : params.value
    }
  }
}

export function rfqTimeGetter(params: TypedValueGetterParams<AuditDetail>) {
  const data = params.node.data
  if (data?.negotiation) {
    const rfqTerminateTime = data.negotiation.lastUpdatedAt
    const rfqStartTime = data.negotiation.rfqStartTime
    return moment(rfqTerminateTime).diff(moment(rfqStartTime))
  }
  return null
}

export function rfqTimeFormatter(params: ValueFormatterParams) {
  return isNil(params.value) ? '' : getFormattedTime(params.value)
}
